// extracted by mini-css-extract-plugin
export default {"componentWrapper":"CustomersTable_componentWrapper__yjXfD","loaderWrapper":"CustomersTable_loaderWrapper__QDHbM","tableWrapper":"CustomersTable_tableWrapper__kY0UM"};